
import {CommonModule} from '@/store/module/common'
import {Component, Vue} from 'vue-property-decorator'
import SideBar from './sideBar.vue'
import TopBar from './topBar.vue'
import levitated from '../views/ball/levitated.vue'
import {menuData1} from './menuData'

@Component({
	name: 'Layout',
	components: {
		SideBar,
		TopBar,
		levitated
	}
})
export default class Layout extends Vue {
	get isHideRightBar() {
		return CommonModule.isHideRightBar
	}

	clickLogo() {
		const homeObj = {
			id: 'home',
			isActive: true,
			name: '首页',
			path: '/'
		}
		const sideBarRef = this.$refs.sideBar as SideBar
		sideBarRef.handleClickMenu(menuData1[0], false)
		sideBarRef.openPage(homeObj)
	}

	changeNavStatus() {
		const sideBarRef = this.$refs.sideBar as SideBar
		sideBarRef.changeBillStatus()
	}

	clickBill() {
		this.$router.push('/bill/remain')
	}
}
